import { css, SerializedStyles } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives';

export const learningButtonStyles = {
  basic: css({
    fontFamily: 'Charlie Text, sans-serif',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    cursor: 'pointer',
    textDecoration: 'none',
    justifyContent: 'center',
    maxWidth: 'max-content',
    width: '100%',

    '&:hover': {
      backgroundColor: token('color.background.selected.bold.hovered'),
      borderColor: token('color.border.selected'),
      color: token('color.text.inverse'),
      textDecoration: 'none',
    },

    '&:active': {
      backgroundColor: token('color.background.selected.bold.pressed'),
      borderColor: token('color.border.selected'),
      color: token('color.text.inverse'),
    },

    '&:disabled': {
      backgroundColor: token('color.background.disabled'),
      borderColor: 'transparent',
      color: token('color.text.disabled'),
      cursor: 'not-allowed',
    },
  }),

  primary: css({
    padding: `10px ${token('space.150')}`,
    backgroundColor: token('color.background.brand.bold'),
    borderColor: token('color.border.brand'),
    color: token('color.text.inverse'),

    '&:focus-visible': {
      outline: `2px solid ${token('color.border.focused')}`,
    },
  }),

  secondary: css({
    padding: `10px ${token('space.150')}`,
    backgroundColor: 'transparent',
    borderColor: token('color.border.brand'),
    color: token('color.text.brand'),
  }),

  danger: css({
    padding: `10px ${token('space.150')}`,
    backgroundColor: token('color.background.danger.bold'),
    borderColor: token('color.border.danger'),
    color: token('color.text.inverse'),
  }),

  warning: css({
    padding: `10px ${token('space.150')}`,
    backgroundColor: token('color.background.warning.bold'),
    borderColor: token('color.border.warning'),
    color: token('color.text.warning.inverse'),
  }),

  subtle: css({
    padding: `10px ${token('space.150')}`,
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    color: token('color.text'),
  }),

  success: css({
    padding: `10px ${token('space.150')}`,
    backgroundColor: token('color.background.success.bold'),
    borderColor: token('color.border.success'),
    color: token('color.text.inverse'),
  }),

  selected: css({
    backgroundColor: token('color.background.selected'),
    borderColor: 'transparent',
    color: token('color.text.brand'),

    '&:hover': {
      backgroundColor: token('color.background.selected'),
      borderColor: 'transparent',
      color: token('color.text.brand'),
    },
  }),
} as { [key: string]: SerializedStyles };

export const learningButtonFontStyles = {
  medium: css({
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
  }),
  large: css({
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 600,
  }),
} as { [key: string]: SerializedStyles };

export const learningButtonSpacingStyles = {
  medium: css({
    padding: `10px ${token('space.150')}`,
  }),
  'medium-icon-before': css({
    padding: `10px ${token('space.150')} 10px 10px`,
  }),
  'medium-icon-after': css({
    padding: `10px 10px 10px ${token('space.150')}`,
  }),
  large: css({
    maxWidth: 'max-content',
    padding: `${token('space.150')} ${token('space.200')}`,
  }),
  'large-icon-before': css({
    padding: `${token('space.150')} ${token('space.200')} ${token('space.150')} ${token('space.150')}`,
  }),
  'large-icon-after': css({
    padding: `${token('space.150')} ${token('space.150')} ${token('space.150')} ${token('space.200')}`,
  }),
} as { [key: string]: SerializedStyles };

export const learningButtonResponsiveSpacing = {
  large: css({
    [media.below.sm]: {
      padding: `10px ${token('space.150')}`,
    },
  }),
  'large-icon-before': css({
    [media.below.sm]: {
      padding: `10px ${token('space.150')} 10px 10px`,
    },
  }),
  'large-icon-after': css({
    [media.below.sm]: {
      padding: `10px 10px 10px ${token('space.150')}`,
    },
  }),
} as { [key: string]: SerializedStyles };

export const learningButtonResponsiveFontStyles = css({
  [media.below.sm]: {
    fontSize: '16px',
    lineHeight: '20px',
  },
});

export const buttonIconContainerStyles = css({
  width: '24px',
  height: '24px',
});

export const disabledIconStyles = css({
  color: token('color.icon.disabled'),
  cursor: 'not-allowed',
});

export const loadingStyles = css({
  backgroundColor: token('color.background.disabled'),
  borderColor: 'transparent',
  color: token('color.text.disabled'),

  '&:hover': {
    backgroundColor: token('color.background.disabled'),
    borderColor: 'transparent',
    color: token('color.text.disabled'),
    cursor: 'not-allowed',
  },
});
